var map = {
	"./AXIOM-faction-banner.png": 44022,
	"./BRAVOS-faction-banner.png": 34645,
	"./LYRA-faction-banner.png": 99382,
	"./MUNA-faction-banner.png": 33543,
	"./ORDIS-faction-banner.png": 49285,
	"./YZMIR-faction-banner.png": 23395
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 44513;